import axios from 'axios';

import APP_CONST from 'const/app-const';
import ADMIN_CONST from './const/admin-const';

const SKIP_AUTH_URL = [ 
    '/api/v/web/v1/authentications', 
    
    '/api/web/users-forgotpass', 
    '/api/web/users-resetpass',
    '/api/web/users-verify',
    '/api/web/user/signup',

    '/api/admin/authentications', 
    '/api/admin/user/forgotpass', 
];

function interceptor() {

    axios.defaults.timeout = 30000;
    const env:any = process.env.NODE_ENV;

    if (env !== 'production' && env !== 'staging') {
        axios.defaults.baseURL = `http://${window.location.hostname}:1338`; 
    } else if (env === 'staging') {
        axios.defaults.baseURL = 'https://scorp-app-staging.azurewebsites.net';  
    } else {
        axios.defaults.baseURL = 'https://scorp-app.azurewebsites.net';  
    }

    axios.interceptors.request.use((config) => {

        const { baseURL, url, data, method } = config;
        const uri = String(url).replace(String(baseURL), '');

        // if (env !== 'production') {
            // console.log(`axios request: ${Date.now().toString()}`, url, method, data);
        // }
        if (SKIP_AUTH_URL.indexOf(uri) < 0) {
            if (uri.startsWith('/api/web') || uri.startsWith('/api/v/web')) {

                const userSession = JSON.parse(String(localStorage.getItem(APP_CONST.KEY_STORE_USER)));
                if (userSession && userSession.token) {
                    config.headers['Authorization'] = 'Bearer ' + userSession.token
                }

            } else if (uri.startsWith('/api/admin')) {

                const adminSession = JSON.parse(String(localStorage.getItem(ADMIN_CONST.KEY_STORE_USER)));
                if (adminSession && adminSession.token) {
                    config.headers['Authorization'] = 'Bearer ' + adminSession.token
                }
            }
        }

        return config;
    });

    axios.interceptors.response.use((response) => {

        // if (env !== 'production') {
            // console.log(`axios response: ${Date.now().toString()}`, response.config.url, response.data);
        // }

        // For binary responses, axios already processes them correctly
        // Return response object so client can access response.data for binary data
        // For JSON responses, return response.data
        if (response.config.responseType === 'arraybuffer' || response.config.responseType === 'blob') {
            // Keep full response for binary so response.data is the buffer/blob
            return response;
        }
        // For JSON responses, return just the data
        return response.data;
    }, async(error) => {

        // let errorMessage = error;
        // if (error.response && error.response.data.error) {
        //     errorMessage = error.response.data.error;
        // }
        // throw new Error(errorMessage);

        // message should be attached
        error.message = error.response?.data?.error ?? error.message;
            
        // Remove creating new error object to maintain the original error object from server
        // return Promise.reject(new Error(errorMessage));
        return Promise.reject(error);
    })
}
export default interceptor;